import styled from 'styled-components'
import { color, screenWidth } from 'utils'

const Footer = styled.div`
  display: flex;
  padding: 2rem;
  width: 100%;
  flex-flow: wrap;
  justify-content: center;
  text-align: center;
  border-top: 1px solid ${color('grey000')};

  @media only screen and (max-width: ${screenWidth('sm')}) {
    padding: 1.5rem;
  }
`

export default Footer
